var render = function render(){var _vm=this,_c=_vm._self._c;return _c('webpay-header-base',{staticClass:"bring-up",scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"header-item bahamta-logo",attrs:{"src":"/img/bahamta/logo.svg?v=2"}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }